var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FillPage',{attrs:{"type":_vm.confJson.type,"tip":_vm.messageObj[_vm.tipId],"back-link":_vm.confJson.backLink,"custom-link-label":_vm.confJson.customLinkLabel}})}
var staticRenderFns = []

export { render, staticRenderFns }